import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { useCallback, useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import httpService from "../../../services/httpService";
import { ApiEndpoints, Constants } from "../../../constants/appConstants";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useAuthContext } from "../../../Context/AuthContext";
import {
  ReviewStatusCode,
  Status,
} from "../../ProviderProfile/models";
import { Calendar } from "primereact/calendar";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { useAppContext } from "../../../Context";
import MultipartFileUploadComponent from "../../FileUpload/MultpartFileUploadComponent";
import { ScoKpiDashboardComponent } from "./SCOKpiDashboardComponent";
import { Checkbox } from "primereact/checkbox";
import { FilterService } from "primereact/api";
import { getClientLocalDate, formatClientLocalDate } from "../../../services/dateHelper";

FilterService.register('dateIs', (value: any, filter: any) => {
  if (filter === undefined || filter === null) {
    return true;
  }
  if (value === undefined || value === null) {
    return false;
  }
  const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
  const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
  
  if (!normalizedValue || !normalizedFilter) {
    return false;
  }
  return normalizedValue.getTime() === normalizedFilter.getTime();
});

FilterService.register('dateIsNot', (value: any, filter: any) => {
  if (filter === undefined || filter === null) {
    return true;
  }
  if (value === undefined || value === null) {
    return true;
  }
  const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
  const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
  
  if (!normalizedValue || !normalizedFilter) {
    return true;
  }
  return normalizedValue.getTime() !== normalizedFilter.getTime();
});

interface SCOProvidersComponentProps {
  providerType?: string;
  reviewYear?: number;
}

export const SCOProvidersComponent = ({ providerType: propProviderType, reviewYear: propReviewYear }: SCOProvidersComponentProps = {}) => {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [IsActiveReview, setIsActiveReview] = useState(Boolean);
  const [IsActiveDispute, setIsActiveDispute] = useState(Boolean);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const [markedData, setMarkedData] = useState<any[]>([]);

  const [isLoading, setLoaing] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<any>(null);
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const globalSearchKeys = [
    "mpi",
    "providerAgencyName",
    "reviewStatus",
    "currentTier",
  ];
  const [visible, setVisible] = useState(false);
  const [filters, setFilters] = useState<any>(null);
  const { reviewYear: contextReviewYear, providerType: contextProviderType } = useAppContext();
  const providerType = propProviderType ?? contextProviderType;
  const reviewYear = propReviewYear ?? contextReviewYear;
  const { appUser, isFinalReviewer, isAdministrator } = useAuthContext();
  const [statuses, setAllStatuses] = useState<any[]>([]);
  const [kpiRefreshTrigger, setKpiRefreshTrigger] = useState(0);

  const [showDisputeEndDialog, setShowDisputeEndDialog] = useState(false);

  // Loader states for action buttons
  const [reviewCycleLoading, setReviewCycleLoading] = useState(false);
  const [endReviewCycleLoading, setEndReviewCycleLoading] = useState(false);
  const [disputeCycleLoading, setDisputeCycleLoading] = useState(false);
  const [endDisputeCycleLoading, setEndDisputeCycleLoading] = useState(false);

  const logError = (method: string, error: any) => {
    const messages: string[] = [];
    let current = error;
    for (let depth = 0; depth < 3 && current; depth++) {
      if (typeof current?.message === "string") messages.push(current.message);
      current = current?.cause;
    }
    const status = error?.response?.status ?? error?.status;
    console.error(`[ScoProvidersInfoComponent.${method}] Request failed`, {
      status: typeof status === "number" ? status : undefined,
      message: messages.join(" | ") || "Unknown error",
    });
  };

  // api call onload
  useEffect(() => {
    if (reviewYear) {
      fetchAllProviders();
      getAllStatuses();
      setFilters({
        providerAgencyName: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        mpi: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
        },
        reviewStatus: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        reviewerName: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        dateOfTierAssignment: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        currentTier: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        tierChangeStatus: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        passingMeasures: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
        },
        smeInvolvement: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
        },
      });
    }
  }, [reviewYear]);

  useEffect(() => {
    httpService
      .get(`${ApiEndpoints.IsActiveReview}/${providerType}`)
      .then((response: any) => {
        setIsActiveReview(response?.data);
      })
      .catch((error: any) => {
        logError("IsActiveReview", error);
      });
      IsActiveDisputeApi();
  }, [providerType]);

  useEffect(()=>{
    if(markedData && markedData.length>0){
      const updatedData = data.map((provider: any) => {
        const markedProvider = markedData.find((md) => md.providerId === provider.providerId);
        return markedProvider ? { ...provider, ...markedProvider } : provider;
      });
      setData(updatedData);
      setFilteredData(updatedData);
    }
  },[markedData])

  useEffect(() => {
    const timer = setTimeout(() => {
      const filterButtons = document.querySelectorAll('.p-column-filter-menu-button');
      filterButtons.forEach((btn) => {
        btn.setAttribute('title', 'Filter');
      });
    }, 300);
    return () => clearTimeout(timer);
  }, [isLoading, filteredData]);

  const getAllStatuses = () => {
    httpService
      .get<Status[]>(
        `${ApiEndpoints.GetStatus}?providerType=${providerType}`
      )
      .then((response) => {
        setAllStatuses(response.data);
      })
      .catch((error: any) => {
        logError("getAllStatuses", error);
      });
  };

  const getDateOnly = (date: string) => {
    return getClientLocalDate(date);
  };

  const fetchAllProviders = () => {
    setLoaing(true);
    httpService
      .get(`${ApiEndpoints.getScoProvidersData}/${reviewYear}`)
      .then((response: any) => {
        const updatedData = response?.data.map((item: any) => ({
          ...item,
          dateOfTierAssignment: getDateOnly(item.dateOfTierAssignment), // Convert string to Date object
        }));
        setData(updatedData);
        setFilteredData(updatedData);
        // setKpiData(response?.data);
      })
      .catch((error: any) => {
        logError("fetchAllProviders", error);
        const status = error?.response?.status ?? error?.status;
        if (status === 403 || status === 401) {
          navigate(`/unauthorized`);
        }
      })
      .finally(() => {
        // console.log('Finally');
        setLoaing(false);
      });
  };

  const parentSearchHandler = useCallback(
    (value: any, searchColumns: string[], exactMatch: boolean = false) => {
      let filtered = filteredData.filter((item: any) =>
        searchColumns.some((key) => {
          const fieldValue = String(item[key]).toLowerCase();
          if (exactMatch) {
            return fieldValue === value?.toLowerCase();
          }
          return fieldValue.includes(value?.toLowerCase());
        })
      );
      if (value == globalFilterValue) {
        value = "";
        filtered = data;
      }
      if (searchColumns.includes("currentTier")) {
        filtered = filtered.filter((item: any) => {
          return (item["reviewStatus"] === "Review Completed" || item["reviewStatus"] === "Resolution Review Completed");
        });
      }
      setGlobalFilterValue(value);
      setFilteredData(filtered);
    },
    [data]
  );

  const handleSearch = (e: any) => {
    let value = "";
    if (Array.isArray(e) && typeof e.join("") == "string") {
      value = e.join("");
    } else value = e.target.value;
    let filtered = data.filter((item: any) =>
      globalSearchKeys.some((key) => {
        const fieldValue = String(item[key]).toLowerCase();
        return fieldValue.includes(value?.toLowerCase());
      })
    );
    if (value == globalFilterValue) {
      value = "";
      filtered = data;
    }

    setGlobalFilterValue(value);
    setFilteredData(filtered);
  };

  const BeginReviewCycle = () => {
    setReviewCycleLoading(true);
    httpService.get(`${ApiEndpoints.BeginReviewCycle}/${providerType}`)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveReview(true);
          fetchAllProviders();
          setKpiRefreshTrigger(prev => prev + 1);
          syncCalculationData();
        }
      })
      .catch((error: any) => {
        logError("BeginReviewCycle", error);
      })
      .finally(() => {
        setReviewCycleLoading(false);
      });
  };

  const syncCalculationData = () => {
        httpService.get(ApiEndpoints.SyncCalculationData)
            .then((response: any) => {
                if (response.status === 200) {
                }
            })
            .catch((error: any) => {
              logError("syncCalculationData", error);
            });
  } 

  const EndReviewCycle = () => {
    setEndReviewCycleLoading(true);
    httpService.get(`${ApiEndpoints.EndReviewCycle}/${providerType}`)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveReview(false);
        }
      })
      .catch((error: any) => {
        logError("EndReviewCycle", error);
      })
      .finally(() => {
        setEndReviewCycleLoading(false);
      });
  };

  //Dispute Method Region

  const BeginDisputeCycle = () => {
    setDisputeCycleLoading(true);
    httpService.get(`${ApiEndpoints.BeginDisputeCycle}/${providerType}`)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveDispute(true);
          ChangeReviewStatusForDispute();
        }
      })
      .catch((error: any) => {
        logError("BeginDisputeCycle", error);
      })
      .finally(() => {
        setDisputeCycleLoading(false);
      });


  };

  const EndDisputeCycle = () => {
    setEndDisputeCycleLoading(true);
    httpService.get(`${ApiEndpoints.EndDisputeCycle}/${providerType}`)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveDispute(false);
        }
      })
      .catch((error: any) => {
        logError("EndDisputeCycle", error);
      })
      .finally(() => {
        setEndDisputeCycleLoading(false);
        fetchAllProviders();
        setKpiRefreshTrigger(prev=>prev+1)
      });
  };

  const IsActiveDisputeApi = ()=> {
    httpService
      .get(`${ApiEndpoints.IsActiveDisputeCycle}/${providerType}`)
      .then((response: any) => {
        setIsActiveDispute(response?.data);
      })
      .catch((error: any) => {
        logError("IsActiveDisputeApi", error);
      })
  }

  const ChangeReviewStatusForDispute = () =>{
    httpService
      .get(`${ApiEndpoints.ChangeReviewStatusForDispute}/${providerType}`)
      .catch((error: any) => {
        logError("ChangeReviewStatusForDispute", error);
      })
      .finally(()=>{
        fetchAllProviders();
        setKpiRefreshTrigger(prev=>prev+1)
      });
  }

    const confirmEndDisputeCycle = () => {
    setShowDisputeEndDialog(true);
  };

  const onConfirmEndDispute = () => {
    setShowDisputeEndDialog(false);
    EndDisputeCycle();
  };

    const onCancelEndDispute = () => {
    setShowDisputeEndDialog(false);
  };
  //End Dispute Method Region

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const confirmEndReview = () => {
    setShowConfirmDialog(true);
  };

  const onConfirmEndReview = () => {
    setShowConfirmDialog(false);
    EndReviewCycle();
  };

  const onCancelEndReview = () => {
    setShowConfirmDialog(false);
  };

  const onSelectedProviderChange = (e: any) => {
    navigate(`/provider`, { state: { provider: e.value, providerType, reviewYear } });
    setSelectedProvider(e.value);
  };

  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between ">
        <IconField iconPosition="left" style={{ alignItems: "end" }}>
          <InputIcon className="pi pi-search" />
          <InputText
            className="width-150"
            value={globalFilterValue}
            onChange={handleSearch}
            placeholder="Search Agency Name or MPI"
          />
        </IconField>
      </div>
    );
  };

  const showDateOfTierAssignment = (rowData: any) => {
    if (rowData.dateOfTierAssignment) {
      return formatClientLocalDate(rowData.dateOfTierAssignment);
    }
  };

  const getKpiIsEnabled = () => Constants.KPI_IS_ENABLED;

  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => {
    const selectedDate = e.value;
    if (selectedDate) {
        const clientDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0);
        options.filterCallback(clientDate, options.index);
    } else {
        options.filterCallback(null, options.index);
    }
}}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const header = renderHeader();
  // State to hold error messages for each provider (by providerId)
  const [cellErrors, setCellErrors] = useState<{
    [providerId: string]: string;
  }>({});

  const markAsCompletedBodyTemplate = (rowData: any) => {
    return (
      <div
        className="flex align-items-center justify-content-center"
        onClick={(e) => e.stopPropagation()}
        style={{ flexDirection: "column" }}
      >
        {!rowData.isCalculating && (
          <span
          className={
            rowData.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ReviewCompleted?.toLowerCase() &&
            (isFinalReviewer() || isAdministrator()) &&
            !(
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoReviewCompleted?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoSMEReview?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoNotStarted?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoInitialReview?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.NotStarted?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionInitialReview?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase() ||
              rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionSMEReview?.toLowerCase() ||
              !(isFinalReviewer() || isAdministrator()) ||
              (IsActiveDispute && rowData.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase())
            )
              ? "checkbox-hoverable"
              : ""
          }
        style={{ display: "inline-block" }}
          >
        <Checkbox
          checked={rowData.reviewStatus === "Review Completed" || (rowData.reviewStatusCode?.toLowerCase() ===
          ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase() )}
          disabled={
            rowData.reviewStatusCode?.toLowerCase() ===
          ReviewStatusCode.ScoReviewCompleted?.toLowerCase() || rowData.reviewStatusCode?.toLowerCase() === 
          ReviewStatusCode.ScoSMEReview?.toLowerCase() || rowData.reviewStatusCode?.toLowerCase() === 
          ReviewStatusCode.ScoNotStarted?.toLowerCase() || rowData.reviewStatusCode?.toLowerCase() === 
          ReviewStatusCode.ScoInitialReview?.toLowerCase() || rowData.reviewStatusCode?.toLowerCase() === 
          ReviewStatusCode.NotStarted?.toLowerCase() ||
            !(isFinalReviewer() || isAdministrator()) || (IsActiveDispute && rowData.reviewStatusCode?.toLowerCase() ===
          ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase() )
          }
          onChange={(e: any) => {
            handleReviewComplete(rowData, e.checked);
          }}
          className="p-checkbox-success"
        />
          </span>
        )}
        
        {rowData.isCalculating && (
          <i
        className="pi pi-spin pi-spinner"
        style={{ fontSize: "1.2em", marginTop: "4px", color: "#26890D" }}
          />
        )}

        {cellErrors[rowData.providerId] && (
          <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
        {cellErrors[rowData.providerId]}
          </span>
        )}
        <style>
          {`
        .checkbox-hoverable .p-checkbox-box {
          transition: box-shadow 0.2s, border-color 0.2s;
        }
        .checkbox-hoverable:hover .p-checkbox-box {
          box-shadow: 0 0 0 2px #26890D33;
          border-color: #26890D;
          cursor: pointer;
        }
          `}
        </style>
      </div>
    );
  };

  // Update handleReviewComplete to set error per cell
  const handleReviewComplete = (rowData: any, isSelected: true) => {
    // Clear previous error for this cell
    setCellErrors((prev) => ({ ...prev, [rowData.providerId]: "" }));

    if (!isFinalReviewer() && !isAdministrator()) {
      setCellErrors((prev) => ({
        ...prev,
        [rowData.providerId]:
          "Only Final Reviewer can mark review as completed.",
      }));
      return;
    }
    // Check if already calculating to prevent multiple API calls
  if (rowData.isCalculating) {
    return;
  }
    if (isSelected) {
      const commonCompletedStatus = IsActiveDispute? ReviewStatusCode.ScoResolutionReviewCompleted : ReviewStatusCode.ScoReviewCompleted
      let completedStatus = statuses.find(
        (s) =>
          s.statusCode.toLowerCase() ===
          commonCompletedStatus.toLowerCase()
      );
      // Immediately update the data state to show spinner and prevent multiple clicks
    const updatedData = data.map((provider: any) => 
      provider.providerId === rowData.providerId 
        ? { ...provider, isCalculating: true }
        : provider
    );
    setData(updatedData);
    setFilteredData(updatedData);

    setMarkedData((prev) => prev.filter((md) => md.providerId !== rowData.providerId));
      // rowData.isCalculating = true;
      // setMarkedData((prev) => prev.filter((md) => md.providerId !== rowData.providerId));
      // setData([...data]); // Trigger re-render to show spinner

      // Call API to update review status
      httpService
        .post(ApiEndpoints.MarkAsCompleted, {
          ProviderId: rowData.providerId,
          StatusId: completedStatus?.statusId,
          reviewerName: appUser?.name ?? appUser?.email,
          ReviewYear: reviewYear,
          MpiId: rowData.mpi,
          providerType: providerType,
        })
        .then((response: any) => {
          if (response.status === 200) {
            let responseData = response?.data;
            responseData.isCalculating = false;
            setMarkedData([...markedData, responseData]);
            setCellErrors((prev) => ({ ...prev, [rowData.providerId]: "" }));
            syncReviewStatusInIntakePortal(completedStatus?.statusId!, rowData.providerId, rowData.mpi);
          }
        })
        .catch((error: any) => {
          logError("handleReviewComplete", error);
          // Reset isCalculating on error
        const resetData = data.map((provider: any) => 
          provider.providerId === rowData.providerId 
            ? { ...provider, isCalculating: false }
            : provider
        );
        setData(resetData);
        setFilteredData(resetData);
        
        setCellErrors((prev) => ({
          ...prev,
          [rowData.providerId]:
            (typeof error?.response?.data?.message === "string"
              ? error.response.data.message
              : "Error updating review status."),
        }));        
      });
    }
  };

    const syncReviewStatusInIntakePortal = (statusId: number, providerId: number, mpi: string) => {
    httpService
      .post(ApiEndpoints.SyncProviderStatusWithIntake, {
        ProviderId: providerId,
        StatusId: statusId,
        reviewerEmail: appUser?.email ?? appUser?.name,
        MpiId: mpi,
      })
      .then((response: any) => {
        if (response.status === 200) {
        }
      })
      .catch((error: any) => {
        logError("syncReviewStatusInIntakePortal", error);
      });
  };

  const getColumnHeaderStyle = (
    minWidth: string,
    width: string = minWidth
  ): React.CSSProperties => ({
    textAlign: "left" as "left",
    minWidth,
    background: "#f8f9fa",
    width,
  });

  const getColumnBodyStyle = (
    width: string = "120px",
    textAlign: string = "center"
  ): React.CSSProperties => ({
    textAlign: textAlign as "left" | "center" | "right",
    background: "#fff",
    width,
    wordBreak: "break-word",
    whiteSpace: "pre-line",
  });

  const getLongTextBody = (field: string, rowData: any) =>
    String(rowData[field]).length > 30 ? (
      <span style={{ whiteSpace: "pre-line" }}>{rowData[field]}</span>
    ) : (
      rowData[field]
    );

  return (
    <>
      {/* <MegaMenu model={navigationItems} breakpoint='960px' /> */}
      <div className="card">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: "10px",
            padding: "15px 25px",
            height: "80px",
            minHeight: "5rem",
          }}
        >
          {(isAdministrator() && !isLoading) && (
            <>
              {/* <Button size='small' className="p-button-secondary" onClick={() => navigate(`/standards`)}>
                                Performance Standards
                            </Button > */}
              {IsActiveReview == false && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={BeginReviewCycle}
                  disabled={reviewCycleLoading}
                >
                  {reviewCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />Begin Review Cycle</>
                  ) : (
                    "Begin Review Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary p-button-danger"
                  onClick={confirmEndReview}
                  disabled={endReviewCycleLoading || disputeCycleLoading}
                >
                  {endReviewCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />End Review Cycle</>
                  ) : (
                    "End Review Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={BeginDisputeCycle}
                  disabled={disputeCycleLoading || endReviewCycleLoading}
                >
                  {disputeCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />Begin Resolution Cycle</>
                  ) : (
                    "Begin Resolution Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == true && (
                <Button
                  size="small"
                  className="p-button-secondary p-button-danger"
                  onClick={confirmEndDisputeCycle}
                  disabled={endDisputeCycleLoading}
                >
                  {endDisputeCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />End Resolution Cycle</>
                  ) : (
                    "End Resolution Cycle"
                  )}
                </Button>
              )}
            </>
          )}
          {/* {IsActiveReview == false ?
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload File
                        </Button> :
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload CLS Data
                        </Button>
                    } */}
        </div>

        <div className="kpi-pie-chart-wrapper">
          {getKpiIsEnabled() && (
            <ScoKpiDashboardComponent
             key={kpiRefreshTrigger}
              searchHandler={parentSearchHandler}
              statuses={statuses}
              reviewYear={reviewYear}
            />
          )}
        </div>

        <Dialog
          header="Upload"
          visible={visible}
          onHide={() => setVisible(false)}
        >
          <div
            className="flex flex-column px-8 py-5 gap-4"
            style={{
              borderRadius: "12px",
              width: "1000px",
              height: "auto",
              minHeight: "300px",
            }}
          >
            <MultipartFileUploadComponent
              allowedExtension="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              maxSize={100000}
              onFileuploaded={() => {
                fetchAllProviders();
              }}
            />
          </div>
          <div>
            <p style={{ textAlign: "center" }}>
              click{" "}
              <a
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/Upload`)}
              >
                here
              </a>{" "}
              to view status of uploaded files
            </p>
          </div>
        </Dialog>

        {/* End review cycle confirmation popup */}
        <Dialog
          header="Confirmation"
          visible={showConfirmDialog}
          onHide={onCancelEndReview}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                label="No"
                icon="pi pi-times"
                onClick={onCancelEndReview}
                className="p-button-text"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                onClick={onConfirmEndReview}
                autoFocus
              />
            </div>
          }
        >
          <div>
            {data.some(
              (provider: any) =>
                provider.reviewStatusCode?.toLowerCase() !==
                ReviewStatusCode.ReviewCompleted?.toLowerCase()
            ) && (
              <p style={{ color: "red" }}>
                Some providers' reviews are not yet completed.
              </p>
            )}
            <p>
              Are you sure you want to <b>End the review cycle</b>?
            </p>
          </div>
        </Dialog>

        <Dialog
          header="Confirmation"
          visible={showDisputeEndDialog}
          onHide={onCancelEndDispute}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                label="No"
                icon="pi pi-times"
                onClick={onCancelEndDispute}
                className="p-button-text"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                onClick={onConfirmEndDispute}
                autoFocus
              />
            </div>
          }
        >
          <p>
            Are you sure you want to <b>End the Resolution Cycle</b>?
          </p>
        </Dialog>

        <div>
          <div style={{ width: "100%" }}>
            <DataTable
              value={filteredData}
              paginator
              header={header}
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50]}
              loading={isLoading}
              filters={filters}
              selectionMode="single"
              selection={selectedProvider}
              onSelectionChange={onSelectedProviderChange}
              dataKey="providerId"
              emptyMessage="No provider found."
              className="responsive-table"
              style={{
                width: "100%",
                tableLayout: "fixed",
                fontSize: "14px",
                background: "#fff",
              }}
            >
              {(isAdministrator() || isFinalReviewer()) && (
              <Column
                header="Mark as Completed"
                body={markAsCompletedBodyTemplate}
                headerStyle={getColumnHeaderStyle("100px")}
                bodyStyle={getColumnBodyStyle("100px")}
              />
              )}
              <Column
                field="providerType"
                header="PBC Type"
                sortable
                filter
                filterPlaceholder="Filter by PBC Type"
                headerStyle={getColumnHeaderStyle("120px")}
                bodyStyle={getColumnBodyStyle("120px")}
              />
              <Column
                field="providerAgencyName"
                header="Agency Name"
                sortable
                filter
                filterPlaceholder="Search by Agency Name"
                headerStyle={getColumnHeaderStyle("140px")}
                bodyStyle={getColumnBodyStyle("140px")}
                body={(rowData) =>
                  getLongTextBody("providerAgencyName", rowData)
                }
              />
              <Column
                field="mpi"
                header="MPI"
                sortable
                filter
                filterPlaceholder="Filter by MPI"
                headerStyle={getColumnHeaderStyle("80px")}
                bodyStyle={getColumnBodyStyle("80px")}
              />
              <Column
                field="reviewStatus"
                header="Review Status"
                sortable
                filter
                filterPlaceholder="Filter by Review Status"
                headerStyle={getColumnHeaderStyle("120px")}
                bodyStyle={getColumnBodyStyle("120px")}
                body={(rowData) => getLongTextBody("reviewStatus", rowData)}
              />
              <Column
                field="reviewerName"
                header="Reviewer"
                sortable
                filter
                filterPlaceholder="Filter by Reviewer"
                headerStyle={getColumnHeaderStyle("100px")}
                bodyStyle={getColumnBodyStyle("100px")}
                body={(rowData) => getLongTextBody("reviewerName", rowData)}
              />
              <Column
                field="currentTier"
                header="Evaluation Outcome"
                sortable
                filter
                filterPlaceholder="Filter by Tier"
                headerStyle={getColumnHeaderStyle("120px")}
                bodyStyle={getColumnBodyStyle("120px")}
                body={(rowData) => getLongTextBody("currentTier", rowData)}
              />
              {isAdministrator() && <Column
                field="dateOfTierAssignment"
                header="Completion Date"
                sortable
                filter
                dataType="date"
                filterElement={dateFilterTemplate}
                filterPlaceholder="Filter by Date of Tier Assignment"
                body={(rowData) => showDateOfTierAssignment(rowData)}
                headerStyle={getColumnHeaderStyle("120px")}
                bodyStyle={getColumnBodyStyle("120px")}
              />}
              {(isAdministrator() || isFinalReviewer()) && (
              <Column
                field="smeInvolvement"
                header="SME Involvement"
                sortable
                filter
                filterPlaceholder="Filter by SME Involvement"
                headerStyle={getColumnHeaderStyle("120px")}
                bodyStyle={getColumnBodyStyle("120px")}
                body={(rowData) =>
                  getLongTextBody("smeInvolvement", rowData) + " %"
                }
              />
              )}
              {(isAdministrator() || isFinalReviewer()) && (
              <Column
                field="passingMeasures"
                header="Passing Measures"
                sortable
                filter
                filterPlaceholder="Filter by Passing Measures"
                headerStyle={getColumnHeaderStyle("120px", "120px")}
                bodyStyle={getColumnBodyStyle("120px", "center")}
                body={(rowData) =>
                  getLongTextBody("passingMeasures", rowData) + " %"
                }
              />
              )}
            </DataTable>
          </div>

          <style>
            {`
                    .responsive-table .p-datatable-wrapper {
                        width: 100%;
                        overflow-x: auto;
                    }
                    .responsive-table .p-datatable-table {
                        width: 100%;
                        table-layout: auto;
                        border-collapse: separate;
                        border-spacing: 0;
                    }
                    .responsive-table .p-datatable-thead > tr > th,
                    .responsive-table .p-datatable-tbody > tr > td {
                        font-size: 14px;
                        padding: 10px 8px;
                        white-space: nowrap;
                        border-bottom: 1px solid #e0e0e0;
                    }
                    .responsive-table .p-datatable-thead > tr > th {
                        background: #f8f9fa;
                        font-weight: 600;
                        color: #333;
                    }
                    .responsive-table .p-datatable-tbody > tr > td {
                        background: #fff;
                        color: #222;
                    }
                    @media (max-width: 1200px) {
                        .responsive-table .p-datatable-thead > tr > th,
                        .responsive-table .p-datatable-tbody > tr > td {
                            font-size: 13px;
                            padding: 8px 4px;
                        }
                    }
                    @media (max-width: 900px) {
                        .responsive-table .p-datatable-thead > tr > th,
                        .responsive-table .p-datatable-tbody > tr > td {
                            font-size: 12px;
                            padding: 6px 2px;
                        }
                    }
                    `}
          </style>

          <style>
            {`
                    .responsive-table .p-datatable-thead > tr > th {
                        text-align: left !important;
                        vertical-align: middle !important;
                        white-space: nowrap;
                        padding: 8px 4px;
                    }
                    .responsive-table .p-column-header-content {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 4px;
                    }
                    @media (max-width: 1200px) {
                        .responsive-table .p-datatable-thead > tr > th,
                        .responsive-table .p-datatable-tbody > tr > td {
                            font-size: 13px;
                            padding: 6px 2px;
                        }
                    }
                    @media (max-width: 900px) {
                        .responsive-table .p-datatable-thead > tr > th,
                        .responsive-table .p-datatable-tbody > tr > td {
                            font-size: 12px;
                            padding: 4px 1px;
                        }
                    }
                    `}
          </style>
        </div>
      </div>
    </>
  );
};